export default __webpack_public_path__ + "static/wmcdacktpa-5295f0f429449241ced3467c7920ef79.webp";